/**
 * Page shell wrapping the Fisher & Paykel header / footer + MUI theme +
 * payment container layout. Pulled out of the old `App.js` so every route
 * shares the same chrome without duplicating the JSX.
 */

import React from 'react';
import { Box } from '@mui/material';

import LoadingSpinner from './LoadingSpinner';

export interface PageShellProps {
  /** Optional id for the outer wrapper (preserved for the original `payment-page` styling hooks). */
  id?: string;
  loading?: boolean;
  children: React.ReactNode;
}

const PageShell: React.FC<PageShellProps> = ({ id = 'payment-page', loading = false, children }) => (
  <div id={id}>
    <Box className="container" sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Box className="payment-container" sx={{ position: 'relative' }}>
        {children}
        <LoadingSpinner isLoading={loading} overlay />
      </Box>
    </Box>
  </div>
);

export default PageShell;
